/**
 * CategoryCardsSkeleton - Loading state for category cards grid
 *
 * Shows 4 skeleton items matching the grid layout
 */

import { Skeleton, useCategoryCardsVariants } from '../../../Theme'
import { SKELETON_COUNTS } from '../../constants'

export function CategoryCardsSkeleton() {
  const {
    categoryCardsGridVariants,
    categoryCardSkeletonVariants,
  } = useCategoryCardsVariants()

  return (
    <>
      {/* Reserve the SectionHeader space the loaded grid renders, so the title doesn't pop in */}
      <Skeleton className="h-10 w-64 mx-auto mb-4" aria-hidden="true" />
      <div
        className={categoryCardsGridVariants()}
        aria-busy="true"
        aria-label="Loading category cards"
      >
        {Array.from({ length: SKELETON_COUNTS.categoryCards }).map((_, index) => (
          <Skeleton key={index} className={categoryCardSkeletonVariants()} />
        ))}
      </div>
    </>
  )
}
